export default lang => {
  return (
    `query countriesQuery($itemPath: String = "/sitecore/content/lynkco-global-portal/Global Setting/Countries") {
      # Datasource query
      # $datasource will always be set to the ID of the rendering's datasource item
      # (as long as the GraphQLData helper is used)
     countries: item(path: $itemPath, language:"${lang}")
      {
        name
        children
        {
          key:field(name:"key")
          {
           value
          }
          phrase:field(name:"phrase")
          {
           value
          }
        }
      }
    }`
  )
} 